import { IdentityCoreBase } from "./identity.core.base"


export class IdentityCore extends IdentityCoreBase {

}